"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentView = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@iconify/react");
var _material = require("@mui/material");
var _reactRouterDom = require("react-router-dom");
require("../../css/documentView.css");
var _DocumentGrid = require("../DocumentManagementView/DocumentGrid.utils");
var _apiPostSummarize = require("@/api/apiPostSummarize");
var _usePostDownloadBlobs2 = require("@/api/usePostDownloadBlobs");
var _usePostPreviewBlobs2 = require("@/api/usePostPreviewBlobs");
var _DetailView = require("@/components/DocumentView/DetailView");
var _DisplayNotAvailable = require("@/components/DocumentView/DisplayNotAvailable");
var _PDFViewer = require("@/components/DocumentView/PDFViewer");
var _SummaryView = require("@/components/DocumentView/SummaryView");
var _Alerts = require("@/components/shared/Alerts/Alerts");
var _DeleteModal = require("@/components/shared/Modal/DeleteModal");
var _EditModal = require("@/components/shared/Modal/EditModal");
var _OverrideModal = require("@/components/shared/Modal/OverrideModal");
var _PermissionsContext = require("@/context/PermissionsContext");
var _usePollingSummarizeStatus = require("@/hooks/usePollingSummarizeStatus");
var _constants = require("@/util/constants");
var _policies = require("@/utils/policies");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var DocumentView = exports.DocumentView = function DocumentView() {
  var _localStorage$getItem;
  var _usePermissions = (0, _PermissionsContext.usePermissions)(),
    hasPermission = _usePermissions.hasPermission;
  var _usePostDownloadBlobs = (0, _usePostDownloadBlobs2.usePostDownloadBlobs)(),
    downloadBlobs = _usePostDownloadBlobs.mutateAsync;
  var _usePostPreviewBlobs = (0, _usePostPreviewBlobs2.usePostPreviewBlobs)(),
    previewBlobs = _usePostPreviewBlobs.mutateAsync;
  var navigate = (0, _reactRouterDom.useNavigate)();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    downloadLoading = _useState2[0],
    setDownloadLoading = _useState2[1];
  var _useSearchParams = (0, _reactRouterDom.useSearchParams)(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    params = _useSearchParams2[0];
  var _useState3 = (0, _react.useState)(_constants.AlertColor.Info),
    _useState4 = _slicedToArray(_useState3, 2),
    alertColor = _useState4[0],
    setAlertColor = _useState4[1];
  var _useState5 = (0, _react.useState)(""),
    _useState6 = _slicedToArray(_useState5, 2),
    alertMessage = _useState6[0],
    setAlertMessage = _useState6[1];
  var _useState7 = (0, _react.useState)(true),
    _useState8 = _slicedToArray(_useState7, 2),
    isExpanded = _useState8[0],
    setIsExpanded = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState0 = _slicedToArray(_useState9, 2),
    downloadedBlob = _useState0[0],
    setDownloadedBlob = _useState0[1];
  var _useState1 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState1, 2),
    showModalEdit = _useState10[0],
    setShowModalEdit = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showModalDelete = _useState12[0],
    setShowModalDelete = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showModalOverride = _useState14[0],
    setShowModalOverride = _useState14[1];
  var _useState15 = (0, _react.useState)("details"),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedTab = _useState16[0],
    setSelectedTab = _useState16[1];
  var _useState17 = (0, _react.useState)(JSON.parse((_localStorage$getItem = localStorage.getItem("doc-".concat(params.get("id")))) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : JSON.stringify({
      id: 0,
      documentName: "",
      fileType: "",
      url: "",
      category: "",
      uploaded: "",
      uploadedBy: "",
      metadata: "",
      previewUrl: ""
    }))),
    _useState18 = _slicedToArray(_useState17, 2),
    documentDetails = _useState18[0],
    setDocumentDetails = _useState18[1];
  var _usePostSummarize = (0, _apiPostSummarize.usePostSummarize)(),
    summarize = _usePostSummarize.mutateAsync;
  var _useState19 = (0, _react.useState)("PENDING"),
    _useState20 = _slicedToArray(_useState19, 2),
    summaryStatus = _useState20[0],
    setSummaryStatus = _useState20[1];
  var _useState21 = (0, _react.useState)(""),
    _useState22 = _slicedToArray(_useState21, 2),
    summary = _useState22[0],
    setSummary = _useState22[1];
  var _usePollingSummarizeS = (0, _usePollingSummarizeStatus.usePollingSummarizeStatus)({
      blob_name: documentDetails === null || documentDetails === void 0 ? void 0 : documentDetails.file_name,
      enabled: summaryStatus !== _constants.SUMMARY_STATUS_SUCCESS && summaryStatus !== _constants.SUMMARY_STATUS_FAILED && hasPermission(_policies.Permission.VIEWER_SUMMARY)
    }),
    currentData = _usePollingSummarizeS.currentData,
    status = _usePollingSummarizeS.status,
    summaryResponse = _usePollingSummarizeS.summary;
  (0, _react.useEffect)(function () {
    if (currentData) {
      if (currentData.httpStatus === 404) {
        startSummarization(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentData]);
  (0, _react.useEffect)(function () {
    setSummaryStatus(status);
    if (summaryResponse) {
      setSummary(summaryResponse);
    }
  }, [status, summaryResponse]);
  var getDisplayedScreen = function getDisplayedScreen(fileType) {
    switch (fileType) {
      case "xls":
      case "xlsx":
      case "csv":
        return /*#__PURE__*/_react["default"].createElement(_DisplayNotAvailable.DisplayNotAvailable, null);
      default:
        return /*#__PURE__*/_react["default"].createElement(_PDFViewer.PDFViewer, {
          blob: downloadedBlob
        });
    }
  };
  var startSummarization = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(updateState) {
      var documentName, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            documentName = documentDetails.file_name;
            _context.next = 4;
            return summarize({
              blob_name: documentName
            });
          case 4:
            response = _context.sent;
            if (!(response.status != 202)) {
              _context.next = 7;
              break;
            }
            throw new Error("Failed to start summarization");
          case 7:
            if (updateState) {
              setSummaryStatus(response.data.status);
            }
            _context.next = 13;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", false);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 10]]);
    }));
    return function startSummarization(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var handleDownloadFile = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _yield$downloadBlobs, data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setDownloadLoading(true);
            _context2.prev = 1;
            _context2.next = 4;
            return downloadBlobs({
              blob_names: [{
                name: documentDetails.documentName,
                uuid: documentDetails.uuid
              }],
              folder_path: []
            });
          case 4:
            _yield$downloadBlobs = _context2.sent;
            data = _yield$downloadBlobs.data;
            (0, _DocumentGrid.performDownload)(data, documentDetails.file_extension, documentDetails.documentName);
            _context2.next = 13;
            break;
          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](1);
            setDownloadLoading(false);
            return _context2.abrupt("return", false);
          case 13:
            setDownloadLoading(false);
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 9]]);
    }));
    return function handleDownloadFile() {
      return _ref2.apply(this, arguments);
    };
  }();
  var renderTab = function renderTab(selectedTab) {
    switch (selectedTab) {
      case "details":
        return /*#__PURE__*/_react["default"].createElement(_DetailView.DetailView, {
          documentDetails: documentDetails
        });
      case "summary":
        return /*#__PURE__*/_react["default"].createElement(_SummaryView.SummaryView, {
          loading: summaryStatus !== _constants.SUMMARY_STATUS_SUCCESS && summaryStatus !== _constants.SUMMARY_STATUS_FAILED,
          summary: summary
        });
      default:
        break;
    }
  };
  var downloadBlob = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return previewBlobs({
              name: documentDetails.documentName,
              uuid: documentDetails.uuid
            });
          case 2:
            response = _context3.sent;
            setDownloadedBlob(response);
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function downloadBlob() {
      return _ref3.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    if (!["xls", "xlsx", "csv"].includes(documentDetails.fileType)) {
      downloadBlob();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var editDocumentDetails = function editDocumentDetails(updatedFile, downloadAgain) {
    var editedDocument = _objectSpread(_objectSpread({}, documentDetails), {}, {
      metadata: updatedFile.metadata,
      category: updatedFile.category,
      uploaded: updatedFile.uploaded,
      uploadedBy: updatedFile.uploadedBy
    });
    setDocumentDetails(editedDocument);
    localStorage.setItem("doc-".concat(params.get("id")), JSON.stringify(editedDocument));
    if (downloadAgain) {
      downloadBlob();
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flow-column flex-1",
    "data-testid": "doc_viewer",
    style: {
      backgroundColor: "#F8F8F8"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "document-view-header"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "page-title"
  }, "Document Viewer")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex space-between document-view-title-section"
  }, /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
    title: documentDetails ? documentDetails.documentName : null,
    arrow: true
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "title text-overflow-ellipsis",
    style: {
      maxWidth: "70vw"
    }
  }, documentDetails.documentName)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex",
    style: {
      gap: "8px"
    }
  }, hasPermission(_policies.Permission.VIEWER_EDIT) && /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
    arrow: true,
    title: "Edit file"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "document-view-title-section-btn-icons",
    "data-testid": "edit-button",
    onClick: function onClick() {
      return setShowModalEdit(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
    icon: "mdi:file-edit-outline",
    className: "document-view-title-section-icons"
  }))), hasPermission(_policies.Permission.VIEWER_DOWNLOAD) && /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
    arrow: true,
    title: "Download file"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "document-view-title-section-btn-icons",
    "data-testid": "download-button",
    onClick: handleDownloadFile,
    disabled: downloadLoading
  }, downloadLoading ? /*#__PURE__*/_react["default"].createElement(_material.CircularProgress, {
    size: 15
  }) : /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
    icon: "lucide:download",
    className: "document-view-title-section-icons"
  }))), hasPermission(_policies.Permission.VIEWER_UPDATE) && /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
    arrow: true,
    title: "Update file"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "document-view-title-section-btn-icons",
    "data-testid": "override-button",
    onClick: function onClick() {
      return setShowModalOverride(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
    icon: "eva:file-add-fill",
    className: "document-view-title-section-icons"
  }))), hasPermission(_policies.Permission.VIEWER_DELETE) && /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
    arrow: true,
    title: "Delete file"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "document-view-title-section-btn-icons",
    "data-testid": "delete-button",
    onClick: function onClick() {
      return setShowModalDelete(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
    icon: "material-symbols:delete-outline",
    className: "document-view-title-section-icons"
  }))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "document-view ".concat(isExpanded === false ? "collapsed" : "")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "pdf"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      position: "absolute",
      width: "100%",
      maxWidth: "100%"
    }
  }, getDisplayedScreen(documentDetails.fileType))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "details"
  }, isExpanded && /*#__PURE__*/_react["default"].createElement("div", {
    className: "document-view-doc-details flex flow-column"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "document-view-doc-details-header-section flex"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "document-view-doc-details-collapse-btn cursor-pointer",
    onClick: function onClick() {
      return setIsExpanded(!isExpanded);
    },
    "data-testid": "collapse-button"
  }, /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
    icon: "ep:arrow-right",
    className: "document-view-doc-details-collapse-btn-icon"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "document-view-doc-details-title flex flex-1"
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Information"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "document-view-doc-details-body flex flow-column"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex",
    style: {
      gap: "19px"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flow-column",
    style: {
      gap: "8px"
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return setSelectedTab("details");
    },
    className: "document-view-doc-details-body-header-title",
    style: {
      color: selectedTab === "details" ? "#4d4d4d" : "#b8b8b8",
      fontWeight: selectedTab === "details" ? "400" : "200",
      borderBottom: selectedTab === "details" ? "2px solid green" : "1px solid grey"
    }
  }, "Details")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flow-column",
    style: {
      gap: "8px"
    }
  }, hasPermission(_policies.Permission.VIEWER_SUMMARY) && /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return setSelectedTab("summary");
    },
    className: "document-view-doc-details-body-header-title",
    style: {
      color: selectedTab === "summary" ? "#4d4d4d" : "#b8b8b8",
      fontWeight: selectedTab === "summary" ? "400" : "200",
      borderBottom: selectedTab === "summary" ? "2px solid green" : "1px solid grey",
      cursor: documentDetails.fileType === "csv" || documentDetails.fileType === "xls" || documentDetails.fileType === "xlsx" ? "not-allowed" : "pointer"
    },
    disabled: documentDetails.fileType === "csv" || documentDetails.fileType === "xls" || documentDetails.fileType === "xlsx"
  }, "Summary")), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: documentDetails.fileType === "csv" || documentDetails.fileType === "xls" || documentDetails.fileType === "xlsx" ? "flex" : "none"
    },
    className: "coming_soon_alert"
  }, "Coming soon")), renderTab(selectedTab))), !isExpanded && /*#__PURE__*/_react["default"].createElement("button", {
    className: "document-view-doc-details-expand-btn cursor-pointer",
    onClick: function onClick() {
      return setIsExpanded(!isExpanded);
    }
  }, /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
    icon: "ep:arrow-left",
    className: "document-view-doc-details-expand-btn-icon"
  }))))), showModalEdit && /*#__PURE__*/_react["default"].createElement(_EditModal.EditModal, {
    callbackClose: function callbackClose(updatedFile) {
      setShowModalEdit(false);
      if (updatedFile) {
        setAlertMessage("You have successfully edited the file.");
        setAlertColor(_constants.AlertColor.Success);
        editDocumentDetails(updatedFile);
      }
    },
    file: documentDetails
  }), showModalOverride && /*#__PURE__*/_react["default"].createElement(_OverrideModal.OverrideModal, {
    callbackClose: function callbackClose(fileEdited) {
      setShowModalOverride(false);
      if (fileEdited) {
        setAlertMessage("You have successfully overrided selected file.");
        setAlertColor(_constants.AlertColor.Success);
        setSummaryStatus("PENDING");
        setSummary("");
        editDocumentDetails(fileEdited, true);
      }
    },
    file: documentDetails
  }), showModalDelete && /*#__PURE__*/_react["default"].createElement(_DeleteModal.DeleteModal, {
    callbackClose: function callbackClose(update) {
      setShowModalDelete(false);
      if (update) {
        localStorage.removeItem("doc-".concat(params.get("id")));
        navigate("/");
      }
    },
    documents: [documentDetails]
  }), /*#__PURE__*/_react["default"].createElement(_Alerts.Alerts, {
    alertOpen: alertMessage !== "",
    color: alertColor,
    message: alertMessage,
    handleAlertClose: function handleAlertClose() {
      return setAlertMessage("");
    }
  }));
};